import { createTheme as r } from "../../_mixins/use-theme.js";
import e from "../../_styles/common/light.js";
import m from "../../button/styles/light.js";
import n from "../../input/styles/light.js";
function i(t) {
  const {
    textColorDisabled: o
  } = t;
  return {
    iconColorDisabled: o
  };
}
const u = r({
  name: "InputNumber",
  common: e,
  peers: {
    Button: m,
    Input: n
  },
  self: i
}), a = u;
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input-number/styles/light.js
// module id = 1702
// module chunks = 67